import {IOption} from "@pg-design/select";

export const applicantsOptions: IOption[] = [1, 2, 3, 4].map((number) => ({label: number.toString(), value: number}));
import {IOption} from "@pg-design/select";

export const applicantsOptions: IOption[] = [1, 2, 3, 4].map((number) => ({label: number.toString(), value: number}));
